import { useSelector } from 'react-redux';
import NextLink from 'next/link';

import { selectCurrentUser } from 'features/auth/slice';

import {
  Icon,
  pluralize,
  recordsMatch,
} from '@frontendmentorio/design-system-v2';

import BookmarkButton from '../BookmarkButton';
import LikeButton from '../LikeButton';

export default function Footer({ solution }) {
  const currentUser = useSelector(selectCurrentUser);
  const isCurrentUserSolution = recordsMatch(currentUser, solution.user);

  return (
    <div className="flex items-center justify-between text-neutral-500">
      <div className="flex gap-4 items-center">
        <NextLink
          className="flex gap-2 items-center transition-opacity hover:opacity-60"
          href={`/solutions/${solution.slug}#feedback`}
        >
          <Icon name="comment" style="solid" />

          <span className="text-sm">
            {pluralize(solution.commentCount, 'comment')}
          </span>
        </NextLink>

        <LikeButton
          className="flex gap-2 items-center transition-opacity hover:opacity-60"
          disabled={isCurrentUserSolution}
          isCompact
          solution={solution}
        />
      </div>

      {!isCurrentUserSolution && (
        <BookmarkButton
          className="transition-opacity hover:opacity-60"
          isCompact
          solution={solution}
        />
      )}
    </div>
  );
}
